import { render, staticRenderFns } from "./QrCode.vue?vue&type=template&id=62fa1e4d"
import script from "./QrCode.vue?vue&type=script&lang=js"
export * from "./QrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports